<template>
    <div class="stage">
        <div class="questions-wrapper">
            <div class="questions-block">
                <div class="question-block">
                    <div class="question">
                        Який результат біопсії після проміжного ПЕТ-КТ?
                    </div>
                    <div class="answers">
                        <div class="answer" :class="biopsyResult === 'Позитивний' ? 'active' : ''" @click="biopsyResult = 'Позитивний'">
                            <input type="radio" id="1" name="biopsyResult" v-model="biopsyResult" value="Позитивний" required>
                            <label for="1"><strong>Позитивний</strong></label>
                        </div>
                        <div class="answer" :class="biopsyResult === 'Негативний' ? 'active' : ''" @click="biopsyResult = 'Негативний'">
                            <input type="radio" id="2" name="biopsyResult" v-model="biopsyResult" value="Негативний" required>
                            <label for="2"><strong>Негативний</strong></label>
                        </div>
                    </div>
                </div>

                <error-block />
            </div>
        </div>
    </div>
</template>

<script>
import ErrorBlock from '../../../../../components/Doctor/ErrorBlock';
import { mapMutations, mapGetters } from 'vuex';

export default {
    components : {
        'error-block' : ErrorBlock
    },
    data : () => ({
        biopsyResult : '',
    }),
    computed : {
        ...mapGetters([
            'getBiopsyResult'
        ])
    },
    methods : {
        ...mapMutations([
            'setBiopsyResult',
        ])
    },
    created(){
        this.biopsyResult = this.getBiopsyResult;
    },
    watch : {
        biopsyResult : function(value){
            this.setBiopsyResult(value);
        }
    }
}
</script>

<style lang="scss" scoped>
.stage{
    .questions-wrapper{
        width: 405px;
        height: auto;

        .questions-block{
            padding: 20px 40px;

            .question-block{
                .question{
                    font-size: 26px;
                }

                .answers{
                    padding-bottom: 0;

                    .answer{
                        width: 51%;

                        label{
                            font-size: 12px;
                            font-weight: 300;

                            strong{
                                padding-right: 3px;
                                font-size: 14px;
                            }
                        }
                    }

                    .answer:nth-child(2n){
                        margin-left: 0;
                    }
                }
            }           
        }        
    }
}

@media (min-width: 1024px) and (min-aspect-ratio: 16/9) {
    .stage{
        .questions-wrapper{
            width: 35vw;
            height: auto;

            .questions-block{
                padding: 3.125vw 3.333vw;

                .question-block{
                    .question{
                        font-size: 1.667vw;
                    }

                    .answers{
                        .answer{
                            width: 55%;

                            margin-right: 0;

                            label{
                                font-size: 0.95vw;

                                strong{
                                    font-size: 1.042vw;
                                }
                            }
                        }
                    }
                }           
            }
        }
    }
}

@media (max-width: 599px){
    .stage{
        .questions-wrapper{
            width: 100%;

            .questions-block{
                padding: 5.556vw 5.278vw 6.667vw 5.556vw;

                .question-block{
                    .question{
                        font-size: 5.556vw;
                    }

                     .answers{
                        padding-bottom: 0;

                        .answer{
                            width: 60%;
                        }
                    }
                }
            }
        }
    }
}
</style>